module.exports = {
  hero: {
    title: "Brainstorming for desired perfect Usability",
    description:
      "Our design projects are fresh and simple and will benefit your business greatly. Learn more about our work!",
    bgImage: "img/app-hero-bg.jpg"
  },
  promo: {
    title: "Why small business owners love Kodemi Software?",
    description:
      "Following reasons show advantages of adding AgencyCo to your lead pages, demos and checkouts",
    items: [
      {
        title: "Affordable Development",
        description:
          "Our app development basic price is only $499. At this rate you can get a FULL app package and rapidly share your app with the world.",
        icon: "ti-vector text-white"
      },
      {
        title: "Get on-line fast",
        description:
          "Many app development firms take days or even weeks to build and publish your app. We can develop your app in hours. Seriously.",
        icon: "ti-lock text-white"
      },
      {
        title: "One-stop shop",
        description:
          "Don't know anything about mobile app publishing on App Store or Google Play store? Let us take care of the publishing stuff and allow you to run your business!",
        icon: "ti-eye text-white"
      }
    ]
  },
  aboutUs: {
    title: {
      bold: "Use your android or ios device",
      normal: ""
    },
    description:
      "Following reasons show advantages of adding AgencyCo to your lead pages, demos and checkouts",
    items: [
      {
        title: "Clean Design",
        description:
          "Increase sales by showing true dynamics of your website",
        icon: "ti-vector text-white"
      },
      {
        title: "Secure Data",
        description:
          "Build your online store’s trust using Social Proof & Urgency",
        icon: "ti-lock text-white"
      },
      {
        title: "Retina Ready",
        description:
          "Realize importance of social proof in customer’s purchase decision",
        icon: "ti-eye text-white"
      }
    ]
  },
  price: {
    title: "Pricing Packages",
    description:
      "Uniquely maintain efficient expertise whereas cross functional deliverables. Continually leverage other's competitive mind share whereas enabled channels. ",
    packages: [
      {
        price: "$499",
        license: "Basic",
        isFeatured: false,
        features: [
          "Basic app including 1-3 screens",
          "App Store or Google Play Store submission",
          "",
          "-",
          "-",
          "-",
          "-",
          "-"
        ]
      },
      {
        price: "$999",
        license: "Popular",
        isFeatured: true,
        features: [
          "Standard app including 3-5 screens",
          "App Store submission",
          "Google Play Store submission",
          "App store optimization (ASO)",
          "App icon design", 
          "-",
          "-"
        ]
      },
      {
        price: "$1499+",
        license: "Premium",
        isFeatured: false,
        features: [
          "Premium app including 5-20 screens",
          "App Store submission",
          "Google Play Store submission",
          "App store optimization (ASO)",
          "App icon design",
          "Splash scren design",
          "Premium features"
        ]
      }
    ]
  },
  testimonial: {
    title: "What customer say about us",
    description:
      'Rapidiously morph transparent internal or "organic" sources whereas resource sucking e-business. Conveniently innovate compelling internal.',
    comments: [
      {
        name: "Arabella Ora",
        company: "AgencyCo",
        image: "img/client-2.jpg",
        comment:
          "Completely build backend ROI whereas cross-media metrics. Collaboratively deploy customer directed web-readiness via global testing procedures. Appropriately reinvent distributed innovation without proactive catalysts for change. Distinctively."
      },
      {
        name: "John Charles",
        company: "ThemeTags",
        image: "img/client-1.jpg",
        comment:
          "If you can design one thing you can design everything with Front. Just believe it. Collaboratively repurpose performance based e-commerce without cost. It's beautiful and the coding is done quickly and seamlessly."
      },
      {
        name: "Jeremy Jere",
        company: "WorldCheck",
        image: "img/client-3.jpg",
        comment:
          "The template is really nice and offers quite a large set of options. It's beautiful and the coding is done. If you can design one thing you can design everything with Front. Just believe it."
      },
      {
        name: "Ciaran Kierce",
        company: "AppCo",
        image: "img/client-4.jpg",
        comment:
          "I just wanted to share a quick note and let you know that you guys do a really good job. I’m glad I decided to work with you. It’s really great how easy your websites are to update and manage. I never have any problem at all."
      }
    ]
  },
  contact: {
    title: "Contact with us",
    description:
      "It's very easy to get in touch with us. Just use the contact form or pay us a visit for a coffee at the office.",

    office: "Head Office",
    address: "2915 Ogletown Road, Newark, DE 19713\nU.S.A.",
    // phone: "+63 9856 5831 830",
    email: "info@kodemisoftware.com"
  },
  trustedCompany: [
    "img/client-1-color.png",
    "img/client-6-color.png",
    "img/client-3-color.png",
    "img/client-4-color.png",
    "img/client-5-color.png"
  ],
  trustedCompanyGray: [
    "img/client-1-gray.png",
    "img/client-2-gray.png",
    "img/client-3-gray.png",
    "img/client-4-gray.png",
    "img/client-5-gray.png"
  ],
  trustedCompanyAboutUs: {
    title: "We use the top rated libraries and packages",
    // description: "Rapidiously morph transparent internal or \"organic\" sources whereas resource sucking e-business. Conveniently innovate compelling internal.",
    companies: [
      "img/library-1.png",
      "img/library-2.png",
      "img/library-3.png",
      "img/library-4.png",
      "img/library-5.png",
      "img/library-6.png",
      // "img/library-7.png",
      // "img/library-8.png",
      // "img/library-9.png",
      // "img/library-10.png"
    ]
  },
  teamMember: {
    members: [
      {
        name: "Alfredo",
        designation: "React-native developer",
        image: "img/team-4.jpg",
        social: true
      },
      // {
      //   name: "Sophie",
      //   designation: "Senior Designer",
      //   image: "img/team-3.jpg"
      // },
      // {
      //   name: "Alex",
      //   designation: "Rect-native developer",
      //   image: "img/team-1.jpg"
      // },
      // {
      //   name: "Katie",
      //   designation: "App designer - ASO Specialist",
      //   image: "img/team-2.jpg"
      // }
    ]
  },
  video: {
    link: "https://www.youtube.com/watch?v=9No-FiEInLA"
  }
};
